module.exports = __webpack_public_path__ + "img/AP_WetSnow.44475733.svg";